import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MinLoader } from 'components';
import { NotificationsAlertsCard } from './notificationsAlertsCard';
import { EmptyStateDashboard } from '../emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from '../widgets';
import { Colors, FindLoad, FindSuccessItem } from 'utils';
import { httpRequestsOnSuccessActions, notificationActions } from 'store';

const notificationEnums = {
    all: 'ALL',
    unread: 'UNREAD',
};

const ACTION_TYPE = 'GET_UNREAD_NOTIFICATIONS';
const MARK_ALL = 'MARK_ALL_AS_READ';
const NoteLimit = 10;

export const NotificationsAlerts = ({ handleDeleteWidget }) => {
    const dispatch = useDispatch();
    const [limit, setLimit] = useState(0);
    const noteList = useSelector((state) => state.notifications.unreadNotifications);
    const loader = FindLoad(ACTION_TYPE);
    const loadMark = FindLoad(MARK_ALL);
    const markAllSuccess = FindSuccessItem(MARK_ALL);
    const observerTarget = useRef(null);

    const requestParams = () => {
        return {
            skip: 0,
            limit: limit,
            state: notificationEnums.unread,
        };
    };

    useEffect(() => {
        const loader = limit === 0 ? 'load' : 'noLoad';
        const checkCount = limit - noteList?.count;

        if (noteList?.count ? checkCount < 10 : true) {
            getNotifications(loader);
        }
    }, [limit]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setLimit((prevLimit) => prevLimit + NoteLimit);
                }
            },
            { threshold: 1 }
        );

        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }

        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [observerTarget]);

    useEffect(() => {
        if (markAllSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(MARK_ALL));
            getNotifications('noLoad');
        }
    }, [markAllSuccess]);

    const getNotifications = (loading) => {
        const params = {
            ...requestParams(),
        };
        dispatch(notificationActions.getUnreadNotifications(params, loading));
    };

    const handleMarkAll = () => {
        dispatch(notificationActions.markAllAsRead());
    };

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={4} onClose={handleDeleteWidget}>
            <div className="main-dashboard-card-body dashboard-notifications-body">
                {noteList?.notifications?.length ? (
                    <>
                        <div className="dashboard-notifications-toolbar">
                            <span className="dashboard-notifications-unread-count">{noteList?.count || 0} unread</span>
                            <button
                                type="button"
                                className="dashboard-notifications-mark-all"
                                onClick={handleMarkAll}
                                disabled={!!loadMark?.length}
                            >
                                <span style={{ visibility: loadMark?.length ? 'hidden' : 'visible' }}>Mark all read</span>
                                {!!loadMark?.length && (
                                    <span className="dashboard-notifications-mark-all-spinner">
                                        <MinLoader position={'relative'} color={Colors.ThemeBlue} margin={'0'} small={true} />
                                    </span>
                                )}
                            </button>
                        </div>
                        <div className="dashboard-notifications-wrapper">
                            {noteList?.notifications?.map((item) => (
                                <NotificationsAlertsCard key={item?.id} info={item} getNotifications={getNotifications} />
                            ))}
                            <div className="flex-justify-align-center" ref={observerTarget} style={{ height: 30 }} />
                        </div>
                    </>
                ) : (
                    <EmptyStateDashboard
                        iconId={4}
                        title={'No new notifications'}
                        description={"You're all caught up. New alerts will appear here"}
                    />
                )}
            </div>
        </DashboardWidgetShell>
    );
};
